import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IRecordCategoryNodesVisibilityRequest) {
    (function(Source) {
        Source["SOURCE_UNKNOWN"] = "SOURCE_UNKNOWN";
        Source["WEB_DESKTOP_TOP_NAV"] = "WEB_DESKTOP_TOP_NAV";
        Source["WEB_DESKTOP_TOP_NAV_DROPDOWN"] = "WEB_DESKTOP_TOP_NAV_DROPDOWN";
        Source["WEB_DESKTOP_LEFT_NAV"] = "WEB_DESKTOP_LEFT_NAV";
        /**
     * Deprecated. Replaced with WEB_MOBILE_ROOT_NAV_MENU and WEB_MOBILE_SUB_NAV_MENU
     * @deprecated
     */ Source["WEB_MOBILE_LEFT_NAV"] = "WEB_MOBILE_LEFT_NAV";
        Source["WEB_MOBILE_ROOT_NAV_MENU"] = "WEB_MOBILE_ROOT_NAV_MENU";
        Source["WEB_MOBILE_SUB_NAV_MENU"] = "WEB_MOBILE_SUB_NAV_MENU";
        Source["WEB_DESKTOP_BRAND_LEFT_NAV"] = "WEB_DESKTOP_BRAND_LEFT_NAV";
        Source["WEB_DESKTOP_BREADCRUMB"] = "WEB_DESKTOP_BREADCRUMB";
        Source["WEB_MOBILE_BREADCRUMB"] = "WEB_MOBILE_BREADCRUMB";
        /**
     * @deprecated
     */ Source["WEB_DESKTOP_CAROUSEL_ELEMENT"] = "WEB_DESKTOP_CAROUSEL_ELEMENT";
        /**
     * @deprecated
     */ Source["WEB_MOBILE_CAROUSEL_ELEMENT"] = "WEB_MOBILE_CAROUSEL_ELEMENT";
        Source["WEB_SEARCH_RESULTS_CATEGORY_FILTER"] = "WEB_SEARCH_RESULTS_CATEGORY_FILTER";
        Source["APP_SEARCH_RESULTS"] = "APP_SEARCH_RESULTS";
        Source["APP_NAV_TREE"] = "APP_NAV_TREE";
        Source["APP_CAROUSEL_ELEMENT"] = "APP_CAROUSEL_ELEMENT";
        Source["HOMEPAGE_COMPONENT"] = "HOMEPAGE_COMPONENT";
        Source["CATEGORY_PAGE_COMPONENT"] = "CATEGORY_PAGE_COMPONENT";
        Source["PRODUCT_PAGE_COMPONENT"] = "PRODUCT_PAGE_COMPONENT";
        Source["SIMILAR_PRODUCTS_PAGE_COMPONENT"] = "SIMILAR_PRODUCTS_PAGE_COMPONENT";
    })(IRecordCategoryNodesVisibilityRequest.Source || (IRecordCategoryNodesVisibilityRequest.Source = {}));
    IRecordCategoryNodesVisibilityRequest.build = function(partial) {
        return _object_spread({
            path_identifiers: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IRecordCategoryNodesVisibilityRequest || (IRecordCategoryNodesVisibilityRequest = {}));
export var IRecordCategoryNodesVisibilityRequest;
